function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_73",
  "data-name": "Caminho 73",
  d: "M462.773-158.717a2.113,2.113,0,0,0-1.183,1.117,1.554,1.554,0,0,0,.917,1.783,2.1,2.1,0,0,0,2.566-.467,1.483,1.483,0,0,0-.733-2.383A1.736,1.736,0,0,0,462.773-158.717Z",
  transform: "translate(-395.625 158.88)",
  fill: "#b84ffa"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_76",
  "data-name": "Caminho 76",
  d: "M380.917-153.833v1.167h1.167v7.866l-.533-.067-.55-.05-.05,1.2-.05,1.217h4.85v-.85l.483.333a4.021,4.021,0,0,0,5.75-1.683c1.833-3.8-1-8.116-4.633-7.066a3.373,3.373,0,0,0-1.1.517.686.686,0,0,1-.35.25,6.8,6.8,0,0,1-.15-2v-2h-4.833Zm7.216,4.666a2.792,2.792,0,0,1,.75,2.45c-.167,2.017-1.767,2.667-2.867,1.167a3.735,3.735,0,0,1-.05-3.083A1.4,1.4,0,0,1,388.133-149.167Z",
  transform: "translate(-328.435 155.647)",
  fill: "#b84ffa"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_79",
  "data-name": "Caminho 79",
  d: "M214.5-136.693a3.84,3.84,0,0,0-1.167.483c-.533.367-.667.35-.667-.05,0-.317-.117-.333-2.333-.333H208v2.333h1.167v4.5H208v2.317h5.833v-2.317h-1.167v-1.9c0-2.083.05-2.217,1.033-2.383,1.067-.167,1.133.05,1.133,3.533v3.066H219.5v-2.317h-1.167v-1.9c0-2.1.05-2.217,1.067-2.383,1.067-.167,1.1-.067,1.1,3.466v3.133h4.666v-2.3l-.533-.05-.55-.05L224-132.51c-.083-2.817-.167-3.133-.933-3.733a3.777,3.777,0,0,0-4.3.167l-.783.483-.5-.483a3.14,3.14,0,0,0-1.983-.833A6.153,6.153,0,0,0,214.5-136.693Z",
  transform: "translate(-184.35 140.573)",
  fill: "#b84ffa"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_80",
  "data-name": "Caminho 80",
  d: "M318.92-136.53a4.712,4.712,0,0,0-3.4,2.6,3.445,3.445,0,0,0-.45,2.383,3.783,3.783,0,0,0,.567,2.133,5.544,5.544,0,0,0,9.133,0,3.707,3.707,0,0,0,.567-2.017,4.3,4.3,0,0,0-2.517-4.583A6.489,6.489,0,0,0,318.92-136.53Zm2.35,2.833c.983,1.167.65,3.666-.567,4.166-1.383.567-2.517-1.233-2-3.166.267-1.033.733-1.5,1.517-1.5A1.175,1.175,0,0,1,321.27-133.7Z",
  transform: "translate(-273.555 140.343)",
  fill: "#b84ffa"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_81",
  "data-name": "Caminho 81",
  d: "M455-133.833v1.167h1.333v4.5H455v2.317h6v-2.3l-.533-.05-.55-.05-.05-3.383L459.833-135H455Z",
  transform: "translate(-390.186 138.98)",
  fill: "#b84ffa"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3307",
  "data-name": "Grupo 3307",
  transform: "translate(0 0.647)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_84",
  "data-name": "Caminho 84",
  d: "M65-196.349v1.251h1.273v7.763l-.583-.042-.583-.032v2.492h4.772v-.859l.4.318a3.169,3.169,0,0,0,2.2.679,3.861,3.861,0,0,0,3.33-1.707,4.681,4.681,0,0,0,.9-3.15,4.824,4.824,0,0,0-.817-3.012,3.594,3.594,0,0,0-3.054-1.792,3.37,3.37,0,0,0-2.418.626,3.2,3.2,0,0,1-.488.308,19.073,19.073,0,0,1-.053-2.047v-2.036l-2.439-.011H65Zm7.169,4.634a1.871,1.871,0,0,1,.583.721,4.008,4.008,0,0,1,.011,2.874,1.421,1.421,0,0,1-2.153.583,2.337,2.337,0,0,1-.732-2.047,2.5,2.5,0,0,1,.244-1.379A1.436,1.436,0,0,1,72.169-191.714Z",
  transform: "translate(-65 197.6)",
  fill: "#b84ffa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_86",
  "data-name": "Caminho 86",
  d: "M186.3-167.685a5.421,5.421,0,0,0-2.98,2.206,5.413,5.413,0,0,0,.053,5.2,5.106,5.106,0,0,0,4.592,2.2,5.566,5.566,0,0,0,3.839-1.315c.6-.541,1.082-1.315.859-1.389-.074-.021-.721-.191-1.432-.371l-1.294-.318-.467.467a1.583,1.583,0,0,1-.912.541,1.805,1.805,0,0,1-2.248-1.485l-.042-.318,3.372-.032,3.362-.021v-.689a4.452,4.452,0,0,0-1.315-3.4,5.125,5.125,0,0,0-2.238-1.273A9.239,9.239,0,0,0,186.3-167.685Zm2.6,2.407a1.66,1.66,0,0,1,.6,1.145c0,.2-.064.212-1.633.212h-1.633l.106-.435A1.671,1.671,0,0,1,188.9-165.278Z",
  transform: "translate(-170.204 170.984)",
  fill: "#b84ffa"
}));

function SvgBemobiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Imagem-15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.814,
    height: 13.543,
    viewBox: "0 0 70.814 13.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBemobiLogo);
export default __webpack_public_path__ + "static/media/bemobi-logo.6c276bf7.svg";
export { ForwardRef as ReactComponent };